// jscs:disable requireCamelCaseOrUpperCaseIdentifiers
import React from 'react';
import { connect } from 'react-redux';
import _ from 'lodash';
import linkTag2Initializer from '../../util/linkTag2Initializer';
import { appContext } from '../../util/decorators';
import { formatHeadingText } from '../../util/formatSportHeadingText';
import TranslatedLink from '../TranslatedLink.jsx';
import PageWithSidebars from '../Page/PageWithSidebars.jsx';
import PageHeading from '../PageHeading.jsx';
import sportConfig from '../../config/sports';
import loadSportData from '../../action/loadSportData';
import { loadAction } from '../../util/decorators';
import teamsConfig from '../../config/teams';
import leaguesConfig from '../../config/leagues';

const TEAM_IMG_URL = '//ximg.enetscores.com/cdnimg/amalthea/logo/teamlogo';

const mapStateToProps = state => ({
  siteConfigSports: sportConfig[state.country],
  sportData: state.sportData,
  mappedSportRouteParam: state.mappedSportRouteParam,
  country: state.country,
});

@loadAction(loadSportData)
@connect(mapStateToProps)
@linkTag2Initializer()
@appContext
export default class TeamList extends React.PureComponent {
  render() {
    const { routeParams: { sports }, sportData, siteConfigSports, mappedSportRouteParam, country } = this.props;

    const t = this.context.app.t;
    const leaguesAndTeams = siteConfigSports[mappedSportRouteParam];

    if (!leaguesAndTeams) return null;

    const { leagues, teams } = leaguesAndTeams;

    return (
      <PageWithSidebars>
        <section className="team-page">
          <PageHeading firstPart={formatHeadingText(country, sports)} secondPart={t('TeamIndex.heading')} />
          <div className="highlight-box">
            <div className="section">
                <div className="heading">{t('TeamIndex.popular_teams')}</div>
                <div className="team-list-featured">
                {
                  _.map(teams, teamId => {
                    const teamName = teamsConfig[teamId][country].name;
                    return (
                      <TranslatedLink
                        key={teamId}
                        className="team"
                        routeParams={[sports, _.kebabCase(teamName)]}
                        name="TeamPage"
                      >
                        <div className="icon">
                          <img src={`${TEAM_IMG_URL}/${teamId}`} />
                        </div>
                        <div className="name">{teamName}</div>
                      </TranslatedLink>
                    );
                  })
                }
                </div>
            </div>
          </div>

          {
            _.map(leagues, leagueId => {
              const leagueLogo = require(`../../../assets/leagues/logo_${leagueId}.png`);
              const leagueName = leaguesConfig[leagueId][country].name;
              return (
                <div key={leagueId} className="highlight-box">
                  <TranslatedLink
                    routeParams={[sports, _.kebabCase(leagueName)]}
                    name="LeaguePage"
                    className="section league-box"
                  >
                    <div className="icon">
                      <img src={leagueLogo} />
                    </div>
                    <h3 className="name">{leagueName}</h3>
                  </TranslatedLink>
                  <div className="section iconed-list with-columns">
                    {
                        _.map(sportData[leagueId], team => {
                          return (
                            <TranslatedLink
                              key={team.id}
                              routeParams={[sports, _.kebabCase(team.name)]}
                              className="link"
                              name="TeamPage"
                            >
                              { <img className="icon" src={`${TEAM_IMG_URL}/${team.id}`} /> }
                              {team.name}
                            </TranslatedLink>
                          );
                        })
                    }
                  </div>
                </div>
              );
            })
          }
        </section>
      </PageWithSidebars>
    );
  }
}

TeamList.propTypes = {
  route: React.PropTypes.object,
  sports: React.PropTypes.array,
  sportData: React.PropTypes.object,
  country: React.PropTypes.string,
};



// WEBPACK FOOTER //
// ./src/component/Teams/TeamList.jsx